import { ChangeDetectorRef, Component, ViewChild, inject } from "@angular/core";
import { ModalComponent } from "src/app/_stealth/partials";

export interface LeaveConfirmationConfig {
  title?: string;
  message?: string;
  confirmButtonLabel?: string;
  cancelButtonLabel?: string;
  isClosingPanel?: boolean;
}

@Component({
    selector: 'app-leave-confirmation-modal',
    templateUrl: './leave-confirmation-modal.component.html',
    styleUrls: ['./leave-confirmation-modal.component.scss'],
    standalone: false
})
export class LeaveConfirmationModalComponent {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  @ViewChild('leaveConfirmationModal') private readonly leaveConfirmationModal: ModalComponent;
  isLegacyDeviceManagementMode = false;

  private readonly defaultConfig: LeaveConfirmationConfig = {
    title: '',
    message: 'discard all unsaved changes',
    confirmButtonLabel: 'Yes, leave section',
    cancelButtonLabel: 'Cancel',
    isClosingPanel: false
  };

  config: LeaveConfirmationConfig = { ...this.defaultConfig };

  open(configOrIsClosingPanel?: boolean | Partial<LeaveConfirmationConfig>) {
    if (typeof configOrIsClosingPanel === 'boolean') {
      this.isLegacyDeviceManagementMode = true;
      this.config = this.getLegacyConfig(configOrIsClosingPanel);
      this.changeDetectorRef.detectChanges();
      return this.leaveConfirmationModal.openLg();
    }

    this.isLegacyDeviceManagementMode = false;

    this.config = {
      ...this.defaultConfig,
      ...configOrIsClosingPanel
    };

    this.changeDetectorRef.detectChanges();
    return this.leaveConfirmationModal.open();
  }

  dismiss() {
    this.leaveConfirmationModal.dismiss();
  }

  close() {
    return this.leaveConfirmationModal.close();
  }

  private getLegacyConfig(isClosingPanel: boolean): LeaveConfirmationConfig {
    return {
      ...this.defaultConfig,
      isClosingPanel,
      message: isClosingPanel
        ? 'Closing this side panel will discard all unsaved changes. <br /> Do you wish to continue?'
        : 'Leaving this section will discard all unsaved changes. <br /> Do you wish to continue?',
      confirmButtonLabel: isClosingPanel
        ? 'Yes, close without saving'
        : 'Yes, leave section'
    };
  }
}
